import { render } from "./ProductSubfive.vue?vue&type=template&id=b31b0b06&scoped=true"
import script from "./ProductSubfive.vue?vue&type=script&lang=js"
export * from "./ProductSubfive.vue?vue&type=script&lang=js"

import "./ProductSubfive.vue?vue&type=style&index=0&id=b31b0b06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b31b0b06"]])

export default __exports__